import AuthLayoutPopup from "./auth-layout-popup";

export default AuthLayoutPopup